import { axios } from '@/utils/request'

const api = {

    getGoodsList: '/adminapi/songpei/goodsList',
    deleteGoods: '/adminapi/songpei/goodsDelete',
    setGoodsRank: '/adminapi/songpei/setGoodsRank',
    setItemRank: '/adminapi/songpei/setItemRank',
    editGoods: '/adminapi/songpei/goodsEdit',
    addGoods: '/adminapi/songpei/goodsAdd',
    getGoodsDetail: '/adminapi/songpei/goodsDetail',
    getGoodsItemList: '/adminapi/songpei/itemList',
    addItem: '/adminapi/songpei/itemadd',
    editItem: '/adminapi/songpei/itemedit',
    deleteItem: '/adminapi/songpei/itemdelete',
    getItemDetail: '/adminapi/songpei/itemDetail',


    applyList: '/adminapi/songpei/applyList',
    applyDetail: '/adminapi/songpei/applyDetail',
    editApply: '/adminapi/songpei/editApply',
    applyDelete: '/adminapi/songpei/applyDelete',


    saiquDetail: '/adminapi/songpei/saiquDetail',
    editSaiqu: '/adminapi/songpei/editSaiqu',
    addSaiqu: '/adminapi/songpei/addSaiqu',
    saiquList: '/adminapi/songpei/saiquList',

    saiquCashDetail: '/adminapi/songpei/saiquCashDetail',
    setCash: '/adminapi/songpei/setSaiquCash',


    saijiList: '/adminapi/songpei/saijiList',
    saijiDetail: '/adminapi/songpei/saijiDetail',
    editSaiji: '/adminapi/songpei/editSaiji',
    sjsqOptions: '/adminapi/songpei/sjsqOptions',

    getApplyUserDetail: '/adminapi/songpei/memberDetail',
    editApplyUser: '/adminapi/songpei/applyMemberEdit',

    editSongpeiOrderItem: '/adminapi/songpei/songpeiOrderItemEdit',
    checkSongpeiOrderOK: '/adminapi/songpei/checkSongpeiOrderOK',

}

export default api


export function getApplyOrderDetail(parameter) {
    return axios({
        url: api.getApplyOrderDetail,
        method: 'post',
        data: parameter
    })
}
export function editApplyOrder(parameter) {
    return axios({
        url: api.editApplyOrder,
        method: 'post',
        data: parameter
    })
}
export function refreshOrder(parameter) {
    return axios({
        url: api.refreshOrder,
        method: 'post',
        data: parameter
    })
}

export function getGoodsList(parameter) {
    return axios({
        url: api.getGoodsList,
        method: 'post',
        data: parameter
    })
}
export function deleteGoods(parameter) {
    return axios({
        url: api.deleteGoods,
        method: 'post',
        data: parameter
    })
}
export function setGoodsRank(parameter) {
    return axios({
        url: api.setGoodsRank,
        method: 'post',
        data: parameter
    })
}
export function setItemRank(parameter) {
    return axios({
        url: api.setItemRank,
        method: 'post',
        data: parameter
    })
}
export function editGoods(parameter) {
    return axios({
        url: api.editGoods,
        method: 'post',
        data: parameter
    })
}
export function addGoods(parameter) {
    return axios({
        url: api.addGoods,
        method: 'post',
        data: parameter
    })
}
export function getGoodsDetail(parameter) {
    return axios({
        url: api.getGoodsDetail,
        method: 'post',
        data: parameter
    })
}
export function getGoodsItemList(parameter) {
    return axios({
        url: api.getGoodsItemList,
        method: 'post',
        data: parameter
    })
}
export function addItem(parameter) {
    return axios({
        url: api.addItem,
        method: 'post',
        data: parameter
    })
}
export function editItem(parameter) {
    return axios({
        url: api.editItem,
        method: 'post',
        data: parameter
    })
}
export function deleteItem(parameter) {
    return axios({
        url: api.deleteItem,
        method: 'post',
        data: parameter
    })
}
export function getItemDetail(parameter) {
    return axios({
        url: api.getItemDetail,
        method: 'post',
        data: parameter
    })
}
export function getApplyList(parameter) {
    return axios({
        url: api.applyList,
        method: 'post',
        data: parameter
    })
}
export function getApplyDetail(parameter) {
    return axios({
        url: api.applyDetail,
        method: 'post',
        data: parameter
    })
}
export function editApply(parameter) {
    return axios({
        url: api.editApply,
        method: 'post',
        data: parameter
    })
}



export function getSaijiList(parameter) {
    return axios({
        url: api.saijiList,
        method: 'get',
        params: parameter
    })
}

export function getSaijiDetail(parameter) {
    return axios({
        url: api.saijiDetail,
        method: 'get',
        params: parameter
    })
}

export function editSaiji(parameter) {
    return axios({
        url: api.editSaiji,
        method: 'post',
        data: parameter
    })
}



export function getSaiquList(parameter) {
    return axios({
        url: api.saiquList,
        method: 'get',
        params: parameter
    })
}



export function getSaiquDetail(parameter) {
    return axios({
        url: api.saiquDetail,
        method: 'get',
        params: parameter
    })
}

export function getSaiquCashDetail(parameter) {
    return axios({
        url: api.saiquCashDetail,
        method: 'get',
        params: parameter
    })
}

export function setSaiquCash(parameter) {
    return axios({
        url: api.setCash,
        method: 'post',
        data: parameter
    })
}

export function editSaiqu(parameter) {
    return axios({
        url: api.editSaiqu,
        method: 'post',
        data: parameter
    })
}


export function addSaiqu(parameter) {
    return axios({
        url: api.addSaiqu,
        method: 'post',
        data: parameter
    })
}


export function applyDelete(parameter) {
    return axios({
        url: api.applyDelete,
        method: 'post',
        data: parameter
    })
}



export function sjsqOptions(parameter) {
    return axios({
        url: api.sjsqOptions,
        method: 'post',
        params: parameter
    })
}

export function getApplyUserDetail(parameter) {
    return axios({
        url: api.getApplyUserDetail,
        method: 'post',
        data: parameter
    })
}


export function editApplyUser(parameter) {
    return axios({
        url: api.editApplyUser,
        method: 'post',
        data: parameter
    })
}

export function editSongpeiOrderItem(parameter) {
    return axios({
        url: api.editSongpeiOrderItem,
        method: 'post',
        data: parameter
    })
}

export function checkSongpeiOrderOK(parameter) {
    return axios({
        url: api.checkSongpeiOrderOK,
        method: 'post',
        data: parameter
    })
}
